<template>
    <div class="link-img-list">
        <div class="link-img-list-multiple" v-if="!single">
            <div class="link-img-list-item" v-for="(item,index) in smallList" :key="index" :style="itemStyles">
                <img :src="item.url" height="100%" @click="lv_click(item,index)"/>
                <div class="link-img-list-delete" v-if="!disabled && !!deleteable">
                    <link-icon icon="icon-trash" @click.stop="lv_deleteImg(item,index)"/>
                </div>
                <div class="link-img-list-loading" v-if="loading">
                    <link-icon icon="icon-loading" loading/>
                </div>
            </div>

            <div class="link-img-list-item link-img-list-button" key="link-img-list-button" :style="itemStyles" @click="!loading && lv_getImg()" v-if="!disabled && uploadable">
                <link-icon icon="icon-add" :style="{fontSize: `${width > height ? height : width * 0.3}px`}"/>
                <div class="link-img-list-loading" v-if="loading">
                    <link-icon icon="icon-loading" loading/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "link-img-list",
        props: {
            data: {type: Array, default: () => []},
            headId: {type: String},                                                                                                         //附件头id
            moduleType: {type: String},                                                                                                     //福阿附件模块
            multiple: {type: Boolean, default: true},                                                                                       // 获取图片的时候是否多选
            width: {type: Number, default: 100},                                                                                            // 每张图片显示宽度
            height: {type: Number, default: 100},                                                                                           // 每张图片显示高度
            shape: {type: String, default: 'none', validator: val => LinkUtils.oneOf(val, ['fillet', 'none', 'round'])},                              // 设定弹出框的圆角（fillet）方角（none）圆形（round）
            uploadUrl: {type: String, default: () => `${LinkVue.prefixUrl}/attachment/insertWithFiles`},                                                          // 图片上传时需要的url
            deleteUrl: {type: String, default: () => `${LinkVue.prefixUrl}/attachment/deleteById`},                                                               // 删除图片时需要的url
            single: {type: Boolean},                                                                                                        // 是否为单图模式
            disabled: {type: Boolean, default: false},                                                                                      // 禁用上传以及删除
            deleteable: {tyle: Boolean, default: true},                                                                                     // 是否提供删除图片功能
			uploadable: {tyle: Boolean, default: true},                                                                                     // 是否提供上传图片功能
			autoDelete: {type: Boolean, default: false},                                                                                    // 自动删除
			autoUpload: {type: Boolean, default: false}                                                                                     // 自动上传
        },
        data() {
            return {
                lv_dataBak: LinkUtils.deepCopy(this.data || []),
                lv_news: [],
                lv_deletes: [],
                loading: false,
            }
        },
        watch: {
            data(newVal, oldVal) {
                if (newVal !== oldVal) this.lv_dataBak = LinkUtils.deepCopy(this.data)
            },
        },
        computed: {
            itemStyles() {
                let ret = '';
                if (this.shape === 'round') {
                    let num = this.width > this.height ? this.height : this.width;
                    ret = `${num * 0.5}px`;
                } else if (this.shape === 'fillet') {
                    ret = '10px';
                } else {
                    ret = '0';
                }
                return {
                    width: `${this.width}px`,
                    height: `${this.height}px`,
                    borderRadius: `${ret}`
                }
            },
            /**
             * 缩略图数组，为默认传入数组与新添加数组合并的数组
             * @author  韦胜健
             * @date    2019/1/3 19:51
             */
            smallList() {
                const ret = []
                this.data.forEach(item => ret.push({url: !item ? null : LinkUtils.typeOf(item) === 'object' ? item.smallurl ? item.smallurl : item.attachmentPath : item, new: false}))
                this.lv_news.forEach(item => ret.push({url: item.base64, new: true}))
                return ret
            },
            /**
             * 大图数组，为默认传入数组与新添加数组合并的数组
             * @author  韦胜健
             * @date    2019/1/3 19:51
             */
            bigList() {
                const ret = []
                this.data.forEach(item => ret.push({url: !item ? null : LinkUtils.typeOf(item) === 'object' ? item.bigurl ? item.bigurl : item.attachmentPath : item, new: false}))
                this.lv_news.forEach(item => ret.push({url: item.base64, new: true}))
                return ret
            },
        },
        methods: {
            async save() {
                this.loading = true
                const saveFiles = this.getNewFiles()
                let attachments = []
                if (saveFiles.length > 0) attachments = await this.lv_uploadImages(saveFiles)
                attachments = LinkUtils.typeOf(attachments) === 'array' ? attachments : [attachments]
                const deleteFiles = this.getDeleteFiles()
                deleteFiles.length > 0 && await this.$file.deleteByIds(deleteFiles.map(item => item.id))
                deleteFiles.splice(0, deleteFiles.length)
                attachments.forEach(item => this.data.push(item))
                this.lv_news.splice(0, this.lv_news.length)
                this.lv_deletes.splice(0, this.lv_deletes.length)
                this.lv_dataBak = LinkUtils.deepCopy(this.data)
                this.loading = false

            },
            /**
             * 获取包新建的图片文件
             * @author  韦胜健
             * @date    2019/1/3 19:50
             */
            getNewFiles() {
                return this.lv_news.map(item => item.file)
            },
            /**
             * 互殴去要删除的图片文件
             * @author  韦胜健
             * @date    2019/1/3 19:50
             */
            getDeleteFiles() {
                return this.lv_deletes
            },
            /**
             * 重置
             * @author  韦胜健
             * @date    2019/1/3 20:56
             */
            reset() {
                this.data.splice(0, this.data.length)
                this.lv_dataBak.forEach(item => this.data.push(item))
                this.lv_news.splice(0, this.lv_news.length)
                this.lv_deletes.splice(0, this.lv_deletes.length)
            },
            lv_uploadImages(saveFiles) {
                return new Promise(async (rs, rj) => {
                    this.$file.upload({
                        action: this.uploadUrl,
                        file: saveFiles,
                        data: {headId: this.headId, moduleType: this.moduleType},
                        onSuccess: async (data) => {
                            if (data.success === false) {
                                console.error(data)
                                this.$nav.error(LinkVue.$t('LinkService.fileUploadFail') + data.result)
                                return
                            } else {
                                rs(data.entity)
                            }
                        },
                        onError: (error) => {
                            this.$nav.error(LinkVue.$t('LinkService.fileUploadFail') + error.toString())
                            rj(error)
                        }
                    })
                })
            },
            /**
             * 获取图片动作
             * @author  韦胜健
             * @date    2019/1/3 19:48
             */
            async lv_getImg() {
                const images = await this.$file.getImage(this.multiple)
                images.forEach(item => this.lv_news.push(item))
				if(this.autoUpload) this.save();
            },
            /**
             * 删除图片动作
             * @author  韦胜健
             * @date    2019/1/3 19:49
             * @param item      删除的图片简略信息
             * @param index     删除的图片的简略索引
             */
            async lv_deleteImg(item, index) {
                const i = !!item.new ? (index - this.data.length) : index
                if (!!item.new) {
                    /*删除新建没有保存的图片*/
                    this.lv_news.splice(i, 1)
                } else {
                    /*删除已经保存的图片*/
                    this.lv_deletes.push(this.data[i])
                    this.data.splice(i, 1)
                }
				if(this.autoDelete) this.save();
            },
            /**
             * 点击图片时间
             * @author  韦胜健
             * @date    2019/1/3 20:54
             */
            lv_click(item, index) {
                this.$slider.pick({
                    picData: this.bigList,
                    picKey: 'url',
                    pageIndex: index
                })
            },
        }
    }
</script>

<style lang="scss">
    @include themeify {
        .link-img-list {

            .link-img-list-multiple {
                .link-img-list-item {
                    position: relative;
                    overflow: hidden;
                    display: inline-block;
                    vertical-align: middle;
                    cursor: pointer;

                    &:not(:last-child) {
                        margin-right: 12px;
                    }

                    &.link-img-list-button {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        vertical-align: middle;
                        cursor: pointer;
                        border: 1.6px dashed $color-normal-border;
                        position: relative;

                        &:hover {
                            border-color: $color-primary;
                        }

                        .link-icon {
                            color: $color-normal-border;
                        }
                    }

                    img {
                        display: block;
                    }

                    .link-img-list-delete {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        box-sizing: border-box;
                        padding: 0 12px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        height: 32px;
                        background-color: rgba(black, 0.3);
                        color: white;
                        cursor: default;

                        .link-icon {
                            cursor: pointer;
                        }
                    }
                }

                .link-img-list-loading {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    top: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(black, 0.3);
                    color: white;
                    z-index: 2;
                }
            }
        }

    }
</style>
